import React from 'react';
import '../assets/css/BlogDetailSkeleton.css';

interface BlogDetailSkeletonProps {
  count?: number;
}

const BlogDetailSkeleton: React.FC<BlogDetailSkeletonProps> = ({ count = 1 }) => {
  return (
    <div className="blog-detail-skeleton">
      <div className="blog-skeleton-back-button"></div>

      <article className="blog-skeleton-article">
        <header className="blog-skeleton-header">
          <div className="skeleton-line skeleton-title"></div>
          <div className="skeleton-line skeleton-subtitle"></div>
          <div className="skeleton-line skeleton-subtitle short"></div>
        </header>

        <div className="blog-skeleton-content">
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line short"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line short"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
        </div>
      </article>
    </div>
  );
};

export default BlogDetailSkeleton;
